import { useMargin, useClassNames } from '@magnetic/hooks';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const useButtonClassNames = /* @__PURE__ */ __name(({
  admin,
  block,
  children,
  className,
  destructive,
  icon,
  kind,
  loading,
  margin,
  rightIcon,
  size
}) => {
  const iconOnly = !children && Boolean(icon ? !rightIcon : rightIcon);
  const marginClassNames = useMargin(margin);
  return useClassNames(
    "mds-button",
    {
      "mds-button-admin": admin,
      "mds-button-block": block,
      "mds-button-destructive": destructive,
      "mds-button-icon-only": iconOnly,
      "mds-button-loading": loading,
      [`mds-button-kind-${kind}`]: kind,
      [`mds-button-size-${size}`]: size
    },
    marginClassNames,
    className
  );
}, "useButtonClassNames");

export { useButtonClassNames };
//# sourceMappingURL=use-button-class-names.js.map
